<template>
  <section id="top" class="hero">
    <picture>
      <!-- Phones get a portrait crop so the tall hero isn't a stretched sliver -->
      <source
        media="(max-width: 760px)"
        srcset="/photos/hero-portrait.webp"
        width="1000"
        height="1750"
      />
      <!-- The photo covers the hero, so tablets need ~1350px of it at 1x -->
      <img
        class="hero-bg"
        src="/photos/hero.webp"
        srcset="/photos/hero.webp 2000w, /photos/hero-2400.webp 2400w"
        sizes="(max-width: 1024px) 1350px, 100vw"
        alt=""
        width="2000"
        height="1335"
        fetchpriority="high"
        decoding="async"
      />
    </picture>
    <HeroCards />
    <div class="shell hero-inner">
      <p class="hero-badge">
        <span class="dot" aria-hidden="true"></span>YOUR IDEAS. BUILT TO WORK.
      </p>
      <h1>Less busywork.<br />More business.</h1>
      <p class="hero-lede">
        Websites, apps and connected systems that help your business grow.
        I’m Adrian, your engineer from the first conversation to launch.
      </p>
      <div class="hero-actions">
        <a
          :href="contact.whatsappUrl"
          class="btn btn-primary btn-icon"
          target="_blank"
          rel="noopener noreferrer"
          ><WhatsAppIcon />Chat on WhatsApp<span class="sr-only">
            (opens WhatsApp)</span
          ></a
        >
        <a href="#work" class="btn btn-ghost">See my work <span aria-hidden="true">&nbsp;↗</span></a>
      </div>
      <a href="/connect" class="hero-connect">Instagram, email &amp; all contact links <span aria-hidden="true">→</span></a>
      <ul class="hero-proof">
        <li><strong>6+ years</strong><span>building production systems</span></li>
        <li>
          <strong>Fintech-grade</strong><span>payments and financial reporting</span>
        </li>
        <li><strong>One engineer</strong><span>from first call to launch</span></li>
      </ul>
    </div>
  </section>
  <section class="tech-strip" aria-label="Technologies I work with">
    <div class="marquee">
      <ul class="marquee-track">
        <li v-for="tech in stack" :key="tech">{{ tech }}</li>
      </ul>
      <ul class="marquee-track" aria-hidden="true">
        <li v-for="tech in stack" :key="tech">{{ tech }}</li>
      </ul>
    </div>
  </section>
</template>
<script>
import WhatsAppIcon from "@/components/graphics/WhatsAppIcon.vue";
import HeroCards from "@/components/graphics/HeroCards.vue";
import contact from "@/config/contact";

export default {
  name: "HeroSection",
  components: { WhatsAppIcon, HeroCards },
  data: () => ({
    contact,
    stack: [
      "C#",
      ".NET",
      "Node.js",
      "Vue.js",
      "React",
      "Laravel",
      "Flutter",
      "SQL Server",
      "Azure Functions",
      "AWS",
      "REST APIs",
      "SOAP",
      "SFTP",
      "ETL pipelines",
      "MySQL",
      "Linux",
      "CI/CD",
    ],
  }),
};
</script>
